import Wave from "./OndaCabañaSlider";

const TransitionWave = () => {
  return (
    <div className=" bottom-0 left-0 w-full">  
        <Wave />
    </div>
  );
}

export default TransitionWave